/**
 * Layout components used by the router.
 * Kept in a separate file so router.tsx can export non-components for fast refresh.
 */
import { Outlet } from '@tanstack/react-router';
import { AppLayout } from '@/components/layout/AppLayout';

export function RootLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}

export function AuthenticatedLayout() {
  return <AppLayout />;
}
